import { MidnightTheme } from "../.internal/themes/MidnightTheme";
export default MidnightTheme;
